<template>
    <div>
        <nav-breadcrumb :menu="[{label: branchId ? '编辑分公司' : '新增分公司'}]"/>
        <el-row>
            <el-col>
                <panel label="基本信息">
                    <el-form :model="officeForm" :rules="officeFormRules" ref="officeForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="12" v-if="officeForm.bo__branchNo==''">
                                <el-form-item label="分公司编号：" style="width: 60%">
                                    <el-input value="待生成" disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-else>
                                <el-form-item label="分公司编号：" style="width: 60%">
                                    <el-input v-model="officeForm.bo__branchNo" disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="分公司名称：" prop="bo__branchName" :rules="{required: true, message: '分公司名称不能为空'}" style="width: 60%">
                                    <el-input v-model="officeForm.bo__branchName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="负责人：" prop="bo__contactPerson" :rules="{required: true, message: '负责人不能为空'}" style="width: 60%">
                                    <el-input v-model="officeForm.bo__contactPerson"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系方式：" prop="bo__contactNo" :rules="{required: true, message: '负责人不能为空'}" style="width: 60%">
                                    <el-input v-model="officeForm.bo__contactNo"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="所属地区：" prop="bo__province" :rules="{required: true, message: '所属地区不能为空'}" style="width: 60%">
                                    <el-cascader
                                        v-model="officeForm.bo__province"
                                        :options="provinceOpttions" style="width: 100%" :filterable = "true" clearable
                                    >
                                    </el-cascader>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="状态：" prop="bo__branchStatus" :rules="{required: true, message: '状态不能为空'}" style="width: 60%">
                                    <el-select v-model.trim="officeForm.bo__branchStatus">
                                        <el-option label="禁用" value="Closed"></el-option>
                                        <el-option label="启用" value="Active"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="详细地址：" prop="bo__address" :rules="{required: true, message: '详细地址不能为空'}" style="width: 80%">
                                    <el-input v-model="officeForm.bo__address"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="经度：" prop="bo__longitude" :rules="{required: true, message: '经度不能为空'}" style="width: 60%">
                                    <el-input v-model="officeForm.bo__longitude"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="纬度：" prop="bo__latitude" :rules="{required: true, message: '纬度不能为空'}" style="width: 60%">
                                    <el-input v-model="officeForm.bo__latitude"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="公司照片：" prop="bo__pictureURL" :rules="{required: true, message: '公司照片不能为空'}" style="width: 60%">

                                        <image-upload  v-model="officeForm.bo__pictureURL" prefix="images/"></image-upload>
                                        温馨提示：上传图片尺寸按560*500px最佳

                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="面签室" v-if="branchId!=''">
                    <data-table
                        :table-data="roomData"
                        :columns="columnsRoom"
                        :actions="actionsRoom"
                        :is-pagination-show="false"
                    />
                </panel>
                <panel label="办押点" v-if="branchId!=''">
                    <data-table
                        :table-data="locationData"
                        :columns="columnsLocation"
                        :actions="actionsLocation"
                        :is-pagination-show="false"
                    />
                </panel>
            </el-col>
        </el-row>
        <div class="tr xzmt">
            <el-button type="primary" @click="onSubmit('officeForm')">确认提交</el-button>
            <el-button @click="$router.back()">取消</el-button>
        </div>
        <el-dialog v-if="dialogVisibleRoom" :visible.sync="dialogVisibleRoom" :title="title">
        <el-form :model="roomForm" :rules="roomRules" ref="roomForm" label-width="150px">
            <el-row :gutter="10" class="bg-purple xamhtrpg">

                <el-col :span="24">
                    <el-form-item label="面签室名称：" prop="r__roomName" :rules="{required: true, message: '面签室名称不能为空'}" style="width: 60%">
                        <el-input v-model="roomForm.r__roomName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="所属地区：" prop="r__province" :rules="{required: true, message: '所属地区不能为空'}" style="width: 60%">
                        <el-cascader
                            v-model="roomForm.r__province"
                            :options="provinceOpttions" style="width: 100%" :filterable = "true" clearable
                        >
                        </el-cascader>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="详细地址：" prop="r__address" :rules="{required: true, message: '详细地址不能为空'}" style="width: 80%">
                        <el-input v-model="roomForm.r__address"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="经度：" prop="r__longitude" :rules="{required: true, message: '经度不能为空'}" style="width: 60%">
                        <el-input v-model="roomForm.r__longitude"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="纬度：" prop="r__latitude" :rules="{required: true, message: '纬度不能为空'}" style="width: 60%">
                        <el-input v-model="roomForm.r__latitude"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="状态：" prop="r__disabled" :rules="{required: true, message: '状态不能为空'}" style="width: 60%">
                        <el-select v-model.trim="roomForm.r__disabled">
                            <el-option label="禁用" value="Y"></el-option>
                            <el-option label="启用" value="N"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="会议室ID：" prop="r__liveStreamRef" :rules="{required: false, message: ''}" style="width: 60%">
                        <el-input v-model="roomForm.r__liveStreamRef"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="访问密码：" prop="r__liveStreamPasswd" :rules="{required: false, message: ''}" style="width: 60%">
                        <el-input v-model="roomForm.r__liveStreamPasswd" type="password"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="面签室照片：" prop="r__pictureURL" :rules="{required: true, message: '面签室照片不能为空'}" style="width: 60%">
                        <image-upload  v-model="roomForm.r__pictureURL" prefix="images/"></image-upload>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="tr xzmt">
                <el-button type="primary" @click="onSubmitRoom('roomForm')">确认提交</el-button>
                <el-button @click="dialogVisibleRoom = false">取消</el-button>
            </div>
        </el-form>
    </el-dialog>


        <el-dialog v-if="dialogVisibleLocation" :visible.sync="dialogVisibleLocation" :title="title">
            <el-form :model="locationForm" :rules="locationRules" ref="locationForm" label-width="150px">
                <el-row :gutter="10" class="bg-purple xamhtrpg">

                    <el-col :span="24">
                        <el-form-item label="办押点名称：" prop="lo__locationName" :rules="{required: true, message: '办押点名称不能为空'}" style="width: 60%">
                            <el-input v-model="locationForm.lo__locationName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="所属地区：" prop="lo__province" :rules="{required: true, message: '所属地区不能为空'}" style="width: 60%">
                            <el-cascader
                                v-model="locationForm.lo__province"
                                :options="provinceOpttions" style="width: 100%" :filterable = "true" clearable
                            >
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="详细地址：" prop="lo__address" :rules="{required: true, message: '详细地址不能为空'}" style="width: 80%">
                            <el-input v-model="locationForm.lo__address"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="经度：" prop="lo__longitude" :rules="{required: true, message: '经度不能为空'}" style="width: 60%">
                            <el-input v-model="locationForm.lo__longitude"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="纬度：" prop="lo__latitude" :rules="{required: true, message: '纬度不能为空'}" style="width: 60%">
                            <el-input v-model="locationForm.lo__latitude"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="状态：" prop="lo__disabled" :rules="{required: true, message: '状态不能为空'}" style="width: 60%">
                            <el-select v-model.trim="locationForm.lo__disabled">
                                <el-option label="禁用" value="Y"></el-option>
                                <el-option label="启用" value="N"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                </el-row>
                <div class="tr xzmt">
                    <el-button type="primary" @click="onSubmitLocation('locationForm')">确认提交</el-button>
                    <el-button @click="dialogVisibleLocation = false ;locationForm = {}">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>

</template>

<script>
    import xhr from '../../utils/xhr'
    import citysOptions from '../../utils/citys'
    import {removeItem} from "../../filters/CommonActions";
    export default {
        name: "BranchOfficeAdd",
        data() {
            return {
                branchId:this.$route.query['branchId']||'',
                officeForm:{
                    bo__branchNo:'',
                },
                officeFormRules:{},
                provinceOpttions:[],

                //面签室
                roomForm:{},
                roomRules:{},
                roomData:{},
                columnsRoom:[
                    {
                        type: 'index'
                    },
                    {
                        label: '面签室名称',
                        field: 'r__roomName'
                    },
                    {
                        label: '所属地区',
                        field: 'r__province',
                        formatter: function (r,c,v) {
                            return  (citysOptions.find(item=>item.code === Number(r.r__province))||{}).province+'/'+
                                (citysOptions.find(item=>item.code === Number(r.r__city))||{}).city+'/'+
                                (citysOptions.find(item=>item.code === Number(r.r__district))||{}).district
                        }
                    },
                    {
                        label: '详细地址',
                        field: 'r__address'
                    },
                    {
                        label: '缩略图',
                        field: 'r__pictureURL',
                        render: (r,c,v)=> {
                            return '<img src="/'+v+'.PNG" style="width:50px">'
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '编辑',
                                class: 'el-icon-edit',
                                clickHandler: (index, row)=> {
                                    this.dialogVisibleRoom  =true
                                    this.title = '编辑面签室'
                                    this.getDataRoom(row.r__roomId)
                                }
                            },
                            {
                                label: '删除',
                                class: 'el-icon-delete',
                                clickHandler: (index, row)=> {
                                    removeItem(
                                        xhr.deleteBranchSigningRoom,
                                        {
                                            'r.roomId' : row.r__roomId
                                        },
                                        res=>{
                                            try {
                                                if(res.data.status == 'success') {
                                                    this.getDataRoomList()
                                                }
                                            }catch (e) {

                                            }
                                        }
                                    )
                                }
                            },
                        ]
                    }
                ],
                title:'',
                actionsRoom:[
                    {
                        label: '新增',
                        class: 'el-button--primary',
                        clickHandler: ()=>{
                            this.dialogVisibleRoom  =true
                            this.title = '新增面签室'
                            this.roomForm = {}

                        }
                    }
                ],
                dialogVisibleRoom:false,

                //办押点
                locationForm:{},
                locationRules:{},
                locationData:{},
                columnsLocation:[
                    {
                        type: 'index'
                    },
                    {
                        label: '办押点名称',
                        field: 'lo__locationName'
                    },
                    {
                        label: '所属地区',
                        field: 'lo__province',
                        formatter: function (r,c,v) {
                            return  (citysOptions.find(item=>item.code === Number(r.lo__province))||{}).province+'/'+
                                (citysOptions.find(item=>item.code === Number(r.lo__city))||{}).city+'/'+
                                (citysOptions.find(item=>item.code === Number(r.lo__district))||{}).district
                        }
                    },
                    {
                        label: '详细地址',
                        field: 'lo__address'
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '编辑',
                                class: 'el-icon-edit',
                                clickHandler: (index, row)=> {
                                    this.dialogVisibleLocation  =true
                                    this.title = '编辑办押点'
                                    this.getDataLocation(row.lo__locationId)
                                }
                            },
                            {
                                label: '删除',
                                class: 'el-icon-delete',
                                clickHandler: (index, row)=> {
                                    removeItem(
                                        xhr.deleteBranchPledgeLocation,
                                        {
                                            'lo.locationId' : row.lo__locationId
                                        },
                                        res=>{
                                            try {
                                                if(res.data.status == 'success') {
                                                    this.getDataLocationList()
                                                }
                                            }catch (e) {

                                            }
                                        }
                                    )
                                }
                            },
                        ]
                    }
                ],
                actionsLocation:[
                    {
                        label: '新增',
                        class: 'el-button--primary',
                        clickHandler: ()=>{
                            this.dialogVisibleLocation  =true
                            this.title = '新增办押点'
                            this.locationForm = {
                            }

                        }
                    }
                ],
                dialogVisibleLocation:false,
            }
        },
        mounted() {
            if(this.branchId){
                this.getData()
                this.getDataRoomList()
                this.getDataLocationList()
            }
            this.getprovinceOpttions()
        },
        methods:{
            getprovinceOpttions:function(){
                this.provinceOpttions = citysOptions.reduce( function (total, curr)  {
                    if (curr.province) {
                        total.push({
                            value: curr.code,
                            label: curr.province,
                            children: []
                        })
                    }

                    if(curr.city) {

                        var province_code = (curr.code + '').substr(0,3) + '000'

                        var province = total.find(item=>item.value==province_code)

                        if(province) {

                            province.children.push({

                                value: curr.code,
                                label: curr.city,
                                children: []
                            })

                        }
                    }

                    if(curr.district) {

                        var province_code = (curr.code + '').substr(0,3) + '000'

                        var city_code = (curr.code + '').substr(0,4) + '00'

                        var province = total.find(item=>item.value==province_code)



                        if(province) {

                            var tmp = province.children

                            var city = tmp.find(item=>item.value==city_code)


                            if(city) {


                                city.children.push({

                                    value: curr.code,
                                    label: curr.district
                                })
                            }

                        }
                    }

                    return total
                }, []);

            },
            getData:function(){
                xhr.getBranchOffice({
                        'bo.branchId': this.branchId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.officeForm = res.data.data

                                if(this.officeForm.bo__province||this.officeForm.bo__city||this.officeForm.bo__district){
                                    this.officeForm.bo__province=[parseInt(this.officeForm.bo__province),parseInt(this.officeForm.bo__city),parseInt(this.officeForm.bo__district)]
                                    this.officeForm.bo__province = this.officeForm.bo__province
                                }
                            }
                        }catch (e) {

                        }
                    })
            },
            //面签
            getDataRoomList: function () {
                xhr.getDataRoomList(
                    Object.assign({pageSize:0,'r.branchId':this.branchId}, {},{}),
                    res=> {
                        try {
                            this.roomData = res.data
                        }catch(e){

                        }
                    })

            },
            getDataRoom:function(roomId){
                xhr.getDataRoom({
                        'r.roomId': roomId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.roomForm = res.data.data

                                if(this.roomForm.r__province||this.roomForm.r__city||this.roomForm.r__district){
                                    this.roomForm.r__province=[parseInt(this.roomForm.r__province),parseInt(this.roomForm.r__city),parseInt(this.roomForm.r__district)]
                                    this.roomForm.r__province = this.roomForm.r__province
                                }
                            }
                        }catch (e) {

                        }
                    })
            },
            //办押
            getDataLocationList: function () {
                xhr.getDataLocationList(
                    Object.assign({pageSize:0,'lo.branchId':this.branchId}, {},{}),
                    res=> {
                        try {
                            this.locationData = res.data
                        }catch(e){

                        }
                    })

            },
            getDataLocation:function(locationId){
                xhr.getDataLocation({
                        'lo.locationId': locationId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.locationForm = res.data.data

                                if(this.locationForm.lo__province||this.locationForm.lo__city||this.locationForm.lo__district){
                                    this.locationForm.lo__province=[parseInt(this.locationForm.lo__province),parseInt(this.locationForm.lo__city),parseInt(this.locationForm.lo__district)]
                                    this.locationForm.lo__province = this.locationForm.lo__province
                                }
                            }
                        }catch (e) {

                        }
                    })
            },

            onSubmit: function (formName) {
                let officeForm = this.officeForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        officeForm.bo__checked = true

                        let provinces = officeForm.bo__province
                        officeForm.bo__province=provinces[0]+""
                        officeForm.bo__city=provinces[1]+""
                        officeForm.bo__district=provinces[2]+""
                        xhr.updateBranchOffice(officeForm, res=> {
                            try {
                                if (res.data.status == 'success') {
                                    this.$router.push({
                                        name: 'BranchOfficeListView'
                                    })
                                }
                            } catch (e) {
                            }
                        })
                    }
                })
            },
            onSubmitRoom: function (formName) {
                let roomForm = this.roomForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        roomForm.r__checked = true

                        let provinces = roomForm.r__province
                        roomForm.r__province=provinces[0]+""
                        roomForm.r__city=provinces[1]+""
                        roomForm.r__district=provinces[2]+""
                        roomForm.r__branchId = this.branchId
                        xhr.updateBranchSigningRoom(roomForm, res=> {
                            try {
                                if (res.data.status == 'success') {
                                        this.dialogVisibleRoom = false
                                        this.roomForm = {}
                                    this.getDataRoomList()
                                }
                            } catch (e) {
                            }
                        })
                    }
                })
            },

            onSubmitLocation: function (formName) {
                let locationForm = this.locationForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        locationForm.lo__checked = true

                        let provinces = locationForm.lo__province
                        locationForm.lo__province=provinces[0]+""
                        locationForm.lo__city=provinces[1]+""
                        locationForm.lo__district=provinces[2]+""
                        locationForm.lo__branchId = this.branchId
                        xhr.updateBranchPledgeLocation(locationForm, res=> {
                            try {
                                if (res.data.status == 'success') {
                                    this.dialogVisibleLocation = false
                                    this.locationForm = {}
                                    this.getDataLocationList()
                                }
                            } catch (e) {
                            }
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchOfficeAdd.vue